export default "__VITE_ASSET__CEoVmNSm__"